import { render, staticRenderFns } from "./yek-tyoskentelyjakso.vue?vue&type=template&id=3dddd2ac&scoped=true&"
import script from "./yek-tyoskentelyjakso.vue?vue&type=script&lang=ts&"
export * from "./yek-tyoskentelyjakso.vue?vue&type=script&lang=ts&"
import style0 from "./yek-tyoskentelyjakso.vue?vue&type=style&index=0&id=3dddd2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dddd2ac",
  null
  
)

export default component.exports